<template>
  <header>
    <div class="d-flex justify-space-between flex-wrap mb-4">
      <h2 class="font-weight-600 mb-0 text-capitalize">
      {{ pageHeading }}
      </h2>
     <div class="d-flex flex-wrap" v-if="rightsideButton">
      <slot></slot> <!-- Named slot for rightsideButton -->
     </div>  
    </div>
   
    <div class="d-flex flex-wrap">
      <slot name ="secondaryAction" />
    </div>
  </header>
</template>

<script>
export default {
  props: {
    pageHeading: {
      type: String,
      required: true,
    },
    rightsideButton: {
      type: Boolean,
      required: true,
    },
  },
  data: () => {
    return {};
  },
};
</script>
